export default class RfpBuyersService {
  baseUrl = '/aptitude/api/rfps/';

  constructor(private $http) {
    'ngInject';
  }

  getPricingComparison(
    requestId: number,
    sellerId: number,
    duration: number,
    priceType: string,
    partnerId?: number
  ) {
    let outgoingPriceType = 'Fixed';

    if (priceType === 'VARIABLE' || priceType === 'Variable') {
      outgoingPriceType = 'Variable';
    }

    // TODO: Kemi is looking at moving this url into the new api
    return this.$http.get(
      `/aptitude/buyer/PricingComparisonServiceController/getPricingComparisonForBuyerForSellerTerm`,
      {
        params: {
          calculateExactPrice: false,
          duration,
          partnerId: partnerId ? partnerId : '',
          priceType: outgoingPriceType,
          produceZoomViewValues: true,
          requestId,
          sellerId
        },
        intercept: true,
        cache: true
      }
    );
  }
}
